const protocol = require('@/api/protocol.js')

const response = {}

response.login = (e) => {
  return new Promise((resolve, reject) => {
    const path = '/authLogin'
    const method = 'post'
    const data = {
      email: e.email,
      pw: e.pw
    }
    protocol
      .call(path, method, data)
      .then(res => {
        return resolve(res)
      })
      .catch(err => {
        return reject(err)
      })
  })
}
response.createUser = (e) => {
  return new Promise((resolve, reject) => {
    const path = '/api/auth/login'
    const method = 'post'
    const data = {
      email: e.email,
      password: e.password
    }
    protocol
      .call(path, method, data)
      .then(res => {
        return resolve(res)
      })
      .catch(err => {
        return reject(err)
      })
  })
}

module.exports = response
